import { jwtDecode } from 'jwt-decode';
import sign from 'jwt-encode';

const SECRET = 'auc_3og1f7';

export const decode = (token: string) => jwtDecode(token);

export const encode = (token: any) => sign(token, SECRET);